module.exports = {"360124100":"民和镇","360124101":"李渡镇","360124102":"温圳镇","360124103":"文港镇","360124104":"梅庄镇","360124105":"张公镇","360124106":"罗溪镇","360124107":"架桥镇","360124108":"前坊镇","360124200":"三里乡","360124201":"二塘乡","360124202":"钟陵乡","360124203":"池溪乡","360124204":"南台乡","360124205":"三阳集乡","360124206":"七里乡","360124207":"下埠集乡","360124208":"衙前乡","360124209":"白圩乡","360124210":"长山晏乡","360124211":"泉岭乡","360124500":"五里垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360124.json
// module id = 1367
// module chunks = 0